import { SupportedLanguage } from '@/enum'
import { DropdownOption } from '@/types'

export const GOTHRA_OPTIONS: DropdownOption = {
  [SupportedLanguage.English]: [
    'Bharadwaj',
    'Kashyap',
    'Vashishth',
    'Atri',
    'Gautam',
    'Vishwamitra',
    'Agastya',
    'Jamadagni',
    'Bhrigu',
    'Angiras',
    'Parashar',
    'Shandilya',
    'Kaushik',
    'Dhananjay',
    'Harit',
    'Maitreya',
    'Mudgal',
    'Katyayan',
    'Kutsa',
    'Lomash',
    'Shaunak',
    'Vatsa',
    'Vishnuvardhan',
    'Yajnavalkya',
    'Kapil',
    'Mandavya',
    'Markandeya',
    'Nandan',
    'Pulastya',
    'Pulaha',
    'Rishyashring',
    'Sankritya',
    'Shrivatsa',
    'Suryadhwaj',
    'Upamanyu',
    'Vamdev',
    'Vishnuvriddha',
    'Vyaghrapad',
    'Yaska',
  ],
  [SupportedLanguage.Hindi]: [
    'भरद्वाज',
    'कश्यप',
    'वशिष्ठ',
    'अत्रि',
    'गौतम',
    'विश्वामित्र',
    'अगस्त्य',
    'जमदग्नि',
    'भृगु',
    'अंगिरस',
    'पराशर',
    'शांडिल्य',
    'कौशिक',
    'धनंजय',
    'हरित',
    'मैत्रेय',
    'मुद्गल',
    'कात्यायन',
    'कुत्स',
    'लोमश',
    'शौनक',
    'वत्स',
    'विष्णुवर्धन',
    'याज्ञवल्क्य',
    'कपिल',
    'माण्डव्य',
    'मार्कण्डेय',
    'नंदन',
    'पुलस्त्य',
    'पुलह',
    'ऋष्यशृंग',
    'संकृत्य',
    'श्रीवत्स',
    'सूर्यध्वज',
    'उपमन्यु',
    'वामदेव',
    'विष्णुवृद्ध',
    'व्याघ्रपाद',
    'यास्क',
  ],
  [SupportedLanguage.Marathi]: [
    'भरद्वाज',
    'कश्यप',
    'वशिष्ठ',
    'अत्रि',
    'गौतम',
    'विश्वामित्र',
    'अगस्त्य',
    'जमदग्नि',
    'भृगु',
    'अंगिरस',
    'पराशर',
    'शांडिल्य',
    'कौशिक',
    'धनंजय',
    'हरित',
    'मैत्रेय',
    'मुद्गल',
    'कात्यायन',
    'कुत्स',
    'लोमश',
    'शौनक',
    'वत्स',
    'विष्णुवर्धन',
    'याज्ञवल्क्य',
    'कपिल',
    'मांडव्य',
    'मार्कंडेय',
    'नंदन',
    'पुलस्त्य',
    'पुलह',
    'ऋष्यश्रृंग',
    'सांक्रित्य',
    'श्रीवत्स',
    'सूर्यध्वज',
    'उपमन्यु',
    'वामदेव',
    'विष्णुवृद्ध',
    'व्याघ्रपाद',
    'यास्क',
  ],
  [SupportedLanguage.Gujarati]: [
    'ભરદ્વાજ',
    'કશ્યપ',
    'વશિષ્ઠ',
    'અત્રિ',
    'ગૌતમ',
    'વિશ્વામિત્ર',
    'અગસ્ત્ય',
    'જમદગ્નિ',
    'ભૃગુ',
    'અંગિરસ',
    'પરાશર',
    'શાંડિલ્ય',
    'કૌશિક',
    'ધનંજય',
    'હરિત',
    'મૈત્રેય',
    'મુદ્ગલ',
    'કાત્યાયન',
    'કુત્સ',
    'લોમશ',
    'શૌનક',
    'વત્સ',
    'વિષ્ણુવર્ધન',
    'યાજ્ઞવલ્ક્ય',
    'કપિલ',
    'માંડવ્ય',
    'માર્કંડેય',
    'નંદન',
    'પુલસ્ત્ય',
    'પુલહ',
    'ઋષ્યશૃંગ',
    'સંકૃત્ય',
    'શ્રીવત્સ',
    'સૂર્યધ્વજ',
    'ઉપમન્યુ',
    'વામદેવ',
    'વિષ્ણુવૃદ્ધ',
    'વ્યાઘ્રપાદ',
    'યાસ્ક',
  ],
  [SupportedLanguage.Bengali]: [
    'ভরদ্বাজ',
    'কাশ্যপ',
    'বিশ্ববিশেষ',
    'অত্রি',
    'গৌতম',
    'বিশ্বমিত্র',
    'অগস্ত্য',
    'জামদগ্নি',
    'ভৃগু',
    'অঙ্গিরাস',
    'পরাশর',
    'শাণ্ডিল্য',
    'কৌশিক',
    'ধনঞ্জয়',
    'হারিত',
    'মৈত্রেয়',
    'মুদগল',
    'কট্যায়ন',
    'কুত্স',
    'লোমশ',
    'সৌনক',
    'বৎস',
    'বিশ্ণুয়ার্ধন',
    'যাজ্ঞবল্ক্য',
    'কপিল',
    'মণ্ডব্য',
    'মার্কণ্ডেয়',
    'নন্দন',
    'পুলস্ত্য',
    'পুলহ',
    'ঋষ্যশৃঙ্গ',
    'সংক্রিত',
    'শ্রীবৎস',
    'সূর্যধ্বজ',
    'উপামন্যু',
    'বামদেব',
    'বিশ্ণু বৃদ্ধ',
    'ব্যাঘ্রপদ',
    'যস্ক',
  ],
  [SupportedLanguage.Telugu]: [
    'భారద్వాజ',
    'కశ్యప',
    'వశిష్ఠ',
    'అత్రి',
    'గౌతమ',
    'విశ్వామిత్ర',
    'అగస్త్య',
    'జమదగ్ని',
    'భృగు',
    'అంగిరస',
    'పరాశర',
    'శాండిల్య',
    'కౌశిక',
    'ధనంజయ',
    'హారిత',
    'మైత్రేయ',
    'ముద్గల',
    'కాత్యాయన',
    'కుత్స',
    'లోమశ',
    'శౌనక',
    'వత్స',
    'విష్ణువర్ధన',
    'యాజ్ఞవల్క్య',
    'కపిల',
    'మండవ్య',
    'మార్కండేయ',
    'నందన',
    'పులస్త్య',
    'పులహ',
    'ఋశ్యశృంగ',
    'శంకృత్య',
    'శ్రీవత్స',
    'సూర్యధ్వజ',
    'ఉపమన్యు',
    'వామదేవ',
    'విష్ణువృద్ధ',
    'వ్యాఘ్రపాద',
    'యాస్క',
  ],
  [SupportedLanguage.Kannada]: [
    'ಭಾರದ್ವಾಜ',
    'ಕಶ್ಯಪ',
    'ವಶಿಷ್ಠ',
    'ಅತ್ರಿ',
    'ಗೌತಮ',
    'ವಿಶ್ವಾಮಿತ್ರ',
    'ಅಗಸ್ತ್ಯ',
    'ಜಮದಗ್ನಿ',
    'ಭೃಗು',
    'ಅಂಗಿರಸ',
    'ಪರಾಶರ',
    'ಶಾಂಡಿಲ್ಯ',
    'ಕೌಶಿಕ',
    'ಧನಂಜಯ',
    'ಹರಿತ',
    'ಮೈತ್ರೇಯ',
    'ಮುಡ್ಗಲ',
    'ಕಾತ್ಯಾಯನ',
    'ಕುತ್ಸ',
    'ಲೋಮಶ',
    'ಶೌನಕ',
    'ವತ್ಸ',
    'ವಿಷ್ಣುವರ್ಧನ',
    'ಯಾಜ್ಞವಲ್ಕ್ಯ',
    'ಕಪಿಲ',
    'ಮಾಂಡವ್ಯ',
    'ಮಾರ್ಕಂಡೇಯ',
    'ನಂದನ',
    'ಪುಲಸ್ತ್ಯ',
    'ಪುಲಹ',
    'ಋಶ್ಯಶೃಂಗ',
    'ಶಾಂಕೃತ್ಯ',
    'ಶ್ರೀವತ್ಸ',
    'ಸೂರ್ಯಧ್ವಜ',
    'ಉಪಮನ್ಯು',
    'ವಾಮದೇವ',
    'ವಿಷ್ಣುವೃದ್ಧ',
    'ವ್ಯಾಘ್ರಪಾದ',
    'ಯಾಸ್ಕ',
  ],
  [SupportedLanguage.Tamil]: [
    'பரத்வாஜ',
    'காசிப',
    'வசிஷ்ட',
    'அத்ரி',
    'கௌதம',
    'விஷ்வாமித்ர',
    'அகஸ்திய',
    'ஜமதக்னி',
    'பிரிகு',
    'அங்கிரஸ்',
    'பராசர',
    'ஷாண்டில்ய',
    'கௌஷிக',
    'தனஞ்ஜய',
    'ஹரித',
    'மைத்ரேய',
    'முத்கல',
    'காத்யாயன',
    'குத்ஸ',
    'லோமஷ',
    'ஷௌநக',
    'வத்ஸ',
    'விஷ்ணுவர்தன',
    'யாஜ்ஞவல்க்ய',
    'கபில',
    'மாண்டவ்ய',
    'மார்கண்டேய',
    'நந்தன',
    'புலஸ்த்ய',
    'புலஹ',
    '஋ஷ்யஶ்ரிங்க',
    'சங்க்ரித்ய',
    'ஷ்ரீவத்ஸ',
    'சூர்யத்வஜ',
    'உபமந்யு',
    'வாமதேவ',
    'விஷ்ணுவ',
    'வ்யாக்ரபாத',
    'யாஸ்க',
  ],
  [SupportedLanguage.Odia]: [
    'ଭାରଦ୍ଵାଜ',
    'କଶ୍ୟପ',
    'ବଶିଷ୍ଠ',
    'ଅତ୍ରି',
    'ଗୌତମ',
    'ବିଶ୍ଵାମିତ୍ର',
    'ଅଗସ୍ତ୍ୟ',
    'ଜମଦଗ୍ନି',
    'ଭୃଗୁ',
    'ଅଙ୍ଗୀରସ',
    'ପରାଶର',
    'ଶାଣ୍ଡିଲ୍ୟ',
    'କୌଶିକ',
    'ଧନଞ୍ଜୟ',
    'ହରିତ',
    'ମୈତ୍ରେୟ',
    'ମୁଦ୍ଗଳ',
    'କାତ୍ୟାୟନ',
    'କୁତ୍ସ',
    'ଲୋମଶ',
    'ସୌନକ',
    'ବତ୍ସ',
    'ବିଷ୍ଣୁବର୍ଦ୍ଧନ',
    'ୟାଜ୍ଞବଲ୍କ୍ୟ',
    'କପିଳ',
    'ମାଣ୍ଡବ୍ୟ',
    'ମାର୍କଣ୍ଡେୟ',
    'ନନ୍ଦନ',
    'ପୁଲସ୍ତ୍ୟ',
    'ପୁଲହ',
    'ଋଷ୍ୟଶ୍ରଙ୍ଗ',
    'ସଂକୃତ୍ୟ',
    'ଶ୍ରୀବତ୍ସ',
    'ସୂର୍ଯ୍ୟଧ୍ଵଜ',
    'ଉପମନ୍ୟୁ',
    'ବାମଦେଵ',
    'ବିଷ୍ଣୁବୃଦ୍ଧ',
    'ବ୍ୟାଘ୍ରପାଦ',
    'ୟାସ୍କ',
  ],
  [SupportedLanguage.Malayalam]: [
    'ഭരദ്വാജ',
    'കശ്യപ',
    'വശിഷ്ഠ',
    'അത്രി',
    'ഗൗതമ',
    'വിശ്വാമിത്ര',
    'അഗസ്ത്യ',
    'ജമദഗ്നി',
    'ഭൃഗു',
    'അംഗീരസ്',
    'പരാശര',
    'ശാണ്ഡില്യ',
    'കൗശിക',
    'ധനഞ്ജയ',
    'ഹരിത',
    'മൈത്രേയ',
    'മുദ്ഗല',
    'കാത്യായന',
    'കുത്സ',
    'ലോമശ',
    'സൗനക',
    'വത്സ',
    'വിഷ്ണുവർധന',
    'യാജ്ഞവൽക്യ',
    'കപില',
    'മാണ്ഡവ്യ',
    'മാർക്കണ്ഡേയ',
    'നന്ദന',
    'പുലസ്ത്യ',
    'പുലഹ',
    'ഋഷ്യശൃംഗ',
    'സംകൃത്യ',
    'ശ്രീവത്സ',
    'സൂര്യധ്വജ',
    'ഉപമന്യു',
    'വാമദേവ',
    'വിഷ്ണുവൃദ്ധ',
    'വ്യാഘ്രപാദ',
    'യാസ്ക',
  ],
}
